// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_b0-0";
export var actionModalContentContainer = "_b0-1";
export var createTagButton = "_b0-2";
export var footerContainer = "_b0-7";
export var fullWidthDivider = "_b0-3";
export var hasCreateTagButton = "_b0-4";
export var noCreateTagButton = "_b0-5";
export var tagsContainer = "_b0-6";
export var tagsModalContentContainer = "_b0-8";